import _ from 'lodash';
import React from 'react';

import Table from 'components/Table';
import Money from 'components/Money';
import BooleanIcon from 'components/BooleanIcon';

import {formatDate} from 'utils/datetime';
import {humanReadableBoolean} from 'utils/common';

import './styles.css';

interface DepositSummaryProps {
  depositPaid: boolean;
  depositBalance: number;
  depositPaidBalance: number;
  depositTypeName: string;
  amountToBeRetained: number;
  refundToBeIssued: number;
  depositReleaseDueDate: null | Date;
  amountToBeRetainedPaid: boolean;
  refundToBeIssuedPaid: boolean;
}

interface DepositSummaryTableProps {
  depositSummary: DepositSummaryProps;
  openDepositSummaryDetailModal: () => any;
}

class DepositSummaryTable extends React.Component<DepositSummaryTableProps> {
  render() {
    const {depositSummary, openDepositSummaryDetailModal} = this.props;

    return (
      <div className="DepositSummaryTable">
        <Table className="DepositSummaryTable__table">
          <Table.Header>
            <Table.HeaderItem
              heading="Full deposit paid"
              className="depositPaid"
            />
            <Table.HeaderItem
              heading="Deposit balance"
              className="depositBalance"
            />
            <Table.HeaderItem heading="Deposit type" className="depositType" />
            <Table.HeaderItem
              heading="Deposit paid balance"
              className="depositPaidBalance"
            />
            <Table.HeaderItem
              heading="Amount to be retained"
              className="amountToBeRetained"
            />
            <Table.HeaderItem
              heading="Refund to be issued"
              className="refundRoBeIssued"
            />
            <Table.HeaderItem
              heading="Deposit release due date"
              className="depositReleaseDueDate"
            />
          </Table.Header>
          <Table.Body>
            <Table.Row onClick={openDepositSummaryDetailModal}>
              <Table.Cell className="depositPaid">
                {humanReadableBoolean(depositSummary.depositPaid)}
              </Table.Cell>
              <Table.Cell className="depositBalance">
                <Money amount={depositSummary.depositBalance} balance />
              </Table.Cell>
              <Table.Cell className="depositType">
                {depositSummary.depositTypeName}
              </Table.Cell>
              <Table.Cell className="depositPaidBalance">
                <Money amount={depositSummary.depositPaidBalance} balance />
              </Table.Cell>
              <Table.Cell className="amountToBeRetained">
                <div className="colab-centered-v">
                  <Money amount={depositSummary.amountToBeRetained} />
                  {depositSummary.amountToBeRetainedPaid && (
                    <BooleanIcon
                      className="booleanIcon"
                      value={depositSummary.amountToBeRetainedPaid}
                    />
                  )}
                </div>
              </Table.Cell>
              <Table.Cell className="refundRoBeIssued">
                <div className="colab-centered-v">
                  <Money amount={depositSummary.refundToBeIssued} />
                  {depositSummary.refundToBeIssuedPaid && (
                    <BooleanIcon
                      className="booleanIcon"
                      value={depositSummary.refundToBeIssuedPaid}
                    />
                  )}
                </div>
              </Table.Cell>
              <Table.Cell className="depositReleaseDueDate">
                {depositSummary.depositReleaseDueDate &&
                  formatDate(depositSummary.depositReleaseDueDate)}
                {!depositSummary.depositReleaseDueDate && 'N/A'}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}
export default DepositSummaryTable;
